import type { SyncHistoryItem } from '#/graphql/types';
import FieldDefs from '#/types/FieldDefs';
import { syncSourceList } from './constants';

export type SyncHistoryFormRecord = SyncHistoryItem & {
  result: string;
  createdAt: string;
  organizationName: string;
  syncedByUserName: string;
  updatedAt: string;
  startedAt: string;
  finishedAt: string;
};

const fields = {
  id: {
    dataField: 'id',
    label: 'ID',
    editorOptions: { readOnly: true },
  },
  number: {
    dataField: 'displayNumber',
    label: 'Sync Number',
    editorOptions: { readOnly: true },
  },
  startedAt: {
    dataField: 'startedAt',
    label: 'Started At',
    editorOptions: { readOnly: true },
  },
  finishedAt: {
    dataField: 'finishedAt',
    label: 'Finished At',
    editorOptions: { readOnly: true },
  },
  createdAt: {
    dataField: 'createdAt',
    label: 'Created At',
    editorOptions: { readOnly: true },
  },
  source: {
    dataField: 'source',
    label: 'Source',
    editorType: 'SelectBox',
    editorOptions: {
      readOnly: true,
      items: syncSourceList,
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  type: {
    dataField: 'type',
    label: 'Type',
    editorOptions: { readOnly: true },
  },
  status: {
    dataField: 'status',
    label: 'Status',
    editorOptions: { readOnly: true },
  },
  syncedCount: {
    dataField: 'syncedCount',
    label: 'Synced Items',
    editorOptions: { readOnly: true },
  },
  result: {
    dataField: 'result',
    label: 'Result',
    editorType: 'TextArea',
    editorOptions: { readOnly: true, minHeight: 220, height: 320, autoResizeEnabled: false },
  },
  organizationName: {
    dataField: 'organizationName',
    label: 'Organization',
    editorOptions: { readOnly: true },
  },
  syncedByUserName: {
    dataField: 'syncedByUserName',
    label: 'Synced By',
    editorOptions: { readOnly: true },
  },
  updatedAt: {
    dataField: 'updatedAt',
    label: 'Updated At',
    editorOptions: { readOnly: true },
  },
} satisfies FieldDefs<SyncHistoryFormRecord>;

export default fields;
